export interface FoldingBoxProps {
  body: React.ReactNode
  isBoxOpen: boolean
  close: () => void
  testId?: string
}

export const FoldingBox: React.FC<FoldingBoxProps> = ({
  body,
  isBoxOpen,
  close: _close,
  testId,
}) => {
  return (
    <div
      className={`box-filter ${isBoxOpen ? 'd-block' : 'd-none'}`}
      style={{ visibility: isBoxOpen ? 'visible' : 'hidden' }}
      data-testid={testId}
    >
      <div className="card mb-1">
        <div className="card-body">{body}</div>
      </div>
    </div>
  )
}
